module.exports = __webpack_public_path__ + "img/candle.a331edbd.png";